import axios, { baseUrl } from "../axios/axios";

/**
 * Get user's signature CDN path
 * @returns CDN path string or null if no signature
 */
export const getUserSignature = async (
  userId: number
): Promise<string | null> => {
  const response = await axios.get<string>(
    `${baseUrl}/user/${userId}/signature`
  );
  return response.data || null;
};

/**
 * Upload user signature image
 * Backend will process and remove background automatically
 */
export const uploadUserSignature = async (
  userId: number,
  file: File
): Promise<void> => {
  const formData = new FormData();
  formData.append("signature", file);

  await axios.put(`${baseUrl}/user/${userId}/signature`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

/**
 * Delete user's signature
 */
export const deleteUserSignature = async (userId: number): Promise<void> => {
  await axios.delete(`${baseUrl}/user/${userId}/signature`);
};
